export default __webpack_public_path__ + "static/lilly-4458ac018244e943d0a60d8acaf9d07d.jpg";